export default {
  "gemExchangeTagsAdmin.thead.index": "#NO",
  "gemExchangeTagsAdmin.thead.sort": "排序",
  "gemExchangeTagsAdmin.thead.tagName": "标签名称",
  "gemExchangeTagsAdmin.thead.tagId": "标签Id",
  "gemExchangeTagsAdmin.thead.createdAt": "创建时间",
  "gemExchangeTagsAdmin.thead.updatedAt": "更新新时间",

  "gemExchangeTagsAdmin.add": "新增",
  "gemExchangeTagsAdmin.edit": "编辑",
  "gemExchangeTagsAdmin.details": "详情",
  "gemExchangeTagsAdmin.delete": "删除",
  "gemExchangeTagsAdmin.thead.action": "操作",
};
